import React, { createContext, useCallback, useState } from 'react';

// PanelContext oluşturuyoruz
export const PanelContext = createContext();

export const PanelProvider = ({ children }) => {
  const [selectedPanel, setSelectedPanel] = useState('flow');
  const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);
  const [detailViewRequest, setDetailViewRequest] = useState(null);

  const requestDetailView = useCallback((ticketId, source = 'unknown') => {
    if (!ticketId) return;
    setSelectedPanel('flow');
    setDetailViewRequest({
      ticketId: String(ticketId),
      source,
      requestedAt: Date.now(),
    });
  }, []);

  const clearDetailViewRequest = useCallback(() => {
    setDetailViewRequest(null);
  }, []);
   
  return (
    <PanelContext.Provider
      value={{
        selectedPanel,
        setSelectedPanel,
        isLeftPanelCollapsed,
        setIsLeftPanelCollapsed,
        detailViewRequest,
        requestDetailView,
        clearDetailViewRequest,
      }}
    >
      {children}
    </PanelContext.Provider>
  );
};
